import { render } from "./mobilePayments.vue?vue&type=template&id=48dce818&bindings={\"navigate\":\"props\"}"
import script from "./mobilePayments.vue?vue&type=script&lang=js"
export * from "./mobilePayments.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./mobilePayments.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script